import { ReactElement } from "react";
import { MediaThumbContainer } from "./MediaThumb.style";

export const MediaThumb = ({ children }: { children: ReactElement }) => {
  return (
    <MediaThumbContainer className="media-thumbnail">
      {children}
    </MediaThumbContainer>
  );
};
